import { render } from "./Navbar.vue?vue&type=template&id=318feaba"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=318feaba&lang=scss"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__